
import { useState, useEffect, useContext, useRef } from "react";
import { useStyles } from "../../assets/styles/Theme";
import { useTheme } from "@mui/material/styles";
import SystemAlert from "../../components/common/SystemAlert";
import {
  Box,
  Typography,
  Button,
  Divider,
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  Tooltip,
} from "@mui/material";
import Grid from "@mui/material/Grid2";
import { PageDataContext } from "../../utils/common/PageDataContext";
import ViewDataGridGrnDetails from "../../components/grid/ViewDataGridGrnDetails";
import ViewGrnSupplier from "../../components/grn/ViewGrnSupplier";
import ViewGrnPo from "../../components/grn/ViewGrnPo";
import ViewGrnAttachments from "../../components/grn/ViewGrnAttachments";
import ViewGrnBillInfo from "../../components/grn/ViewGrnBillInfo";
import ViewSidebarOutlinedIcon from "@mui/icons-material/ViewSidebarOutlined";
import DisabledByDefaultOutlinedIcon from "@mui/icons-material/DisabledByDefaultOutlined";
import GrnStatusHistory from "../../components/grn/GrnStatusHistory";
import GrnPdf from "../../features/documents/GrnPdf";
import RejectionNotePdf from "../../features/documents/RejectionNotePdf";
import ReturnNotePdf from "../../features/documents/ReturnNotePdf";
import DebitNotePdf from "../../features/documents/DebitNotePdf";
import ViewGrnReturnInfo from "./ViewGrnReturnInfo";
import { CON_STATUS_HOLDREJECTED, CON_STATUS_RETURN, CON_STATUS_RETURN_SUBMITTED, CON_STATUS_RETURNAPPROVED, CON_STATUS_RETURNREJECTED, CON_STATUS_RETURNSAVED, CON_STATUS_RETURNSUBMITTED, CON_STATUS_Submited } from "../../utils/sys/Constants";
import ViewDataGridGrnDetailsreturn from "../grid/ViewDataGridGrnDetailsreturn";
import ViewReturnPo from "../../components/grn/ViewReturnGrnPo";
import GrnReturnStatusHistory from "../../components/grn/GrnReturnStatusHistory";

function ViewReturnDetailsBody({
  statusCode,
  grnItems,
  selectedSupplier,
  grnDetailsForm,
  attachments,
  grnHeader,
  grncode,
  trackingDetails,
  grnstatuscode,
  grnDocuments,
  grnReturns,
  grnPaySummery,
  grnPayTax,
  grnData,
  totalGross,
  taxValues,
  grnTaxTypes,
  grnCompany,
  grncharges,
  origin,
  addedCharges,
  grnReturnList,
  otherchargevalue
  ,processResponse,grncal,
  calSummary,
  grnreturncode
  ,returneddate
}) {

  const theme = useTheme();
  const styles = useStyles(theme);
  const { setPageData } = useContext(PageDataContext);
  const rightSidebarRef = useRef(null);
  const [docType, setDocType] = useState("");
  const [openPdf, setOpenPdf] = useState(false);
  const [alert, setAlert] = useState({
    open: false,
    type: "success",
    message: "",
  });
  const [rightSidebarOpen, setRightSidebarOpen] = useState(false);

  const handleOpenPdf = (type) => {
    setDocType(type);
    setOpenPdf(true);
  };
  // Toggle function
  const toggleRightSidebar = () => {
    setRightSidebarOpen((prev) => !prev);
  };
  useEffect(() => {
    setPageData({
      title: "Return Summary",
     
    });
  }, []);

  const handleAlertClose = () => {
    setAlert({ ...alert, open: false });
  };

  useEffect(() => {
    function handleClickOutside(event) {
      if (
        rightSidebarRef.current &&
        !rightSidebarRef.current.contains(event.target) &&
        rightSidebarOpen
      ) {
        setRightSidebarOpen(false);
      }
    }

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [rightSidebarOpen]);

  console.log("grncode", grncode);
  console.log("statuscode", statusCode);

  return (
    <>
      <Box
        ref={rightSidebarRef}
        sx={{
          position: "fixed",
          top: 64,
          right: rightSidebarOpen ? 0 : "-320px",
          width: { xs: "80vw", sm: 320 },
          height: "100vh",
          bgcolor: "background.paper",
          boxShadow: 3,
          p: 1,
          zIndex: 1,
          transition: "right 0.3s ease-in-out",
          pointerEvents: "auto", // sidebar accepts pointer events
          display: "flex",
          flexDirection: "column",
          overflowY: "auto",
          scrollbarWidth: "none", // Hide scrollbar in Firefox
          "&::-webkit-scrollbar": {
            display: "none", // Hide scrollbar in WebKit browsers
          },
        }}
      >
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",

            alignItems: "center",
            my: 1,
          }}
        >
          <Typography variant="h6">GRN Tracking</Typography>
          <IconButton
            onClick={toggleRightSidebar}
            size="small"
            aria-label="close sidebar"
          >
            <DisabledByDefaultOutlinedIcon />
          </IconButton>
        </Box>
        <Divider />
        <Box
          sx={{
            flexGrow: 1,
            overflowY: "auto",
            scrollbarWidth: "none", // Hide scrollbar in Firefox
            "&::-webkit-scrollbar": {
              display: "none", // Hide scrollbar in WebKit browsers
            },
          }}
        >
          <GrnStatusHistory
            trackingDetails={trackingDetails}
            grncode={grncode}
          />
        </Box>
      </Box>
      <Box sx={styles.grn_supplier_container}>
        <Grid container spacing={2}>
          <Grid
            item
            size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            <Typography sx={styles.title_text}>
              {statusCode === CON_STATUS_Submited
                ? "Hold GRN"
                : grncode
                ? `GRN : ${grncode}`
                : "Submit GRN"}

              {/* {grncode ? `GRN : ${grncode}` : "Submit GRN"} */}
            </Typography>

          

            <Tooltip title="View History">
              <IconButton
                onClick={toggleRightSidebar}
                disabled={statusCode === CON_STATUS_Submited}
              >
                <ViewSidebarOutlinedIcon />
              </IconButton>
            </Tooltip>
          </Grid>

          <Grid item size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}>
            <Divider />
          </Grid>
          <Grid item size={{ xs: 12, sm: 6, md: 6, lg: 6, xl: 6 }}>
            <Box
              sx={{
                width: {
                  xs: "80%",
                  sm: "80%",
                  md: "50%",
                  lg: "50%",
                  xl: "50%",
                },
              }}
            >
              <ViewGrnSupplier
                onOpenSidebar={toggleRightSidebar}
                selectedSupplier={selectedSupplier}
              statusCode={statusCode} 
                grnHeader={grnHeader}
                grncode={grncode}
                grnstatuscode={grnstatuscode}
                origin ={origin}
               
              />
            </Box>
          </Grid>

          <Grid
            item
            size={{ xs: 12, sm: 6, md: 6, lg: 6, xl: 6 }}
            sx={{
              width: "50%",
              display: "flex",
              justifyItems: "flex-end",
              justifyContent: "flex-end",
            }}
          >
            <Box
              sx={{
                width: {
                  xs: "80%",
                  sm: "80%",
                  md: "50%",
                  lg: "50%",
                  xl: "50%",
                },
                display: "flex",
                justifyItems: "flex-end",
              }}
            >
              <ViewReturnPo
                grnDetailsForm={grnDetailsForm}
                grnHeader={grnHeader}
                grnreturncode={grnreturncode}
                returneddate={returneddate}
              />
            </Box>
          </Grid>
        </Grid>
      </Box>
      <Box>
        <ViewDataGridGrnDetailsreturn
          grnItems={grnItems}
          grnDocuments={grnDocuments}
          grnReturns={grnReturns}
          grnData={grnData}
        />
      </Box>

      {/* Attachenments and price */}

      <Box pt={2} sx={styles.grn_search_container}>
        <Grid container spacing={6}>
          <Grid item size={{ xs: 12, sm: 6, md: 6, lg: 6, xl: 6 }}>
            <Typography sx={styles.grn_sub_title_text} gutterBottom>
              Attached Documents:
            </Typography>
            <Divider />
            <ViewGrnAttachments
              attachments={attachments}
              grnData={grnData}
              grnDocuments={grnDocuments}
            />
          </Grid>
             {![CON_STATUS_RETURNSUBMITTED, "10", CON_STATUS_RETURNREJECTED, CON_STATUS_RETURNSAVED,CON_STATUS_RETURN_SUBMITTED].includes(statusCode) ? (
          <Grid item size={{ xs: 12, sm: 6, md: 6, lg: 6, xl: 6 }}>
            <Typography sx={styles.grn_sub_title_text} gutterBottom>
             Financial Information
            </Typography>
            <Divider />
            <ViewGrnBillInfo
              grnPaySummery={grnPaySummery}
              grnPayTax={grnPayTax}
              grnData={grnData}
              totalGross={totalGross}
              taxValues={taxValues}
              grnTaxTypes={grnTaxTypes}
           grncharges={grncharges}
           addedCharges={addedCharges}
              origin ={origin}
         otherchargevalue={otherchargevalue}
         processResponse={processResponse}
         calSummary={calSummary}
         grncal={grncal}
            />
          </Grid>
          ) : null}
        

               {[CON_STATUS_RETURNSUBMITTED, CON_STATUS_RETURNAPPROVED, CON_STATUS_RETURNREJECTED, CON_STATUS_RETURNSAVED,CON_STATUS_RETURN_SUBMITTED].includes(statusCode) ? (
          <Grid item size={{ xs: 12, sm: 6, md: 6, lg: 6, xl: 6 }}>
            <Typography sx={styles.grn_sub_title_text} gutterBottom>
              Financial Information
            </Typography>
            <Divider />
            <ViewGrnReturnInfo
              grnPaySummery={grnPaySummery}
              grnPayTax={grnPayTax}
              grnData={grnData}
              totalGross={totalGross}
              taxValues={taxValues}
              grnTaxTypes={grnTaxTypes}
          grncharges={grncharges}
          addedCharges={addedCharges}
             origin ={origin}
             grnReturns={grnReturns}
              grnItems={grnItems}
              grnReturnList={grnReturnList}
                   processResponse={processResponse}
            />
          </Grid>
          ) : null}
          {origin !== "CreateGrn" && origin !== "EditGrn" && (
            <Grid
              item
              size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}
              sx={{
                display: "flex",
                justifyContent: "flex-end",
                gap: 2,
              }}
            >
              <Divider />
              {![CON_STATUS_RETURN,CON_STATUS_HOLDREJECTED,CON_STATUS_RETURNSUBMITTED, CON_STATUS_RETURNAPPROVED, CON_STATUS_RETURNREJECTED, CON_STATUS_RETURNSAVED,CON_STATUS_RETURN_SUBMITTED].includes(statusCode) ? (
                <Button
                variant="contained"
                color="primary"
                size="small"
                sx={{ ...styles.btn_primary }}
                onClick={() => handleOpenPdf("Good Received Note")}
              >
                View GRN Note
              </Button>
              ): null}

               {[CON_STATUS_RETURNSUBMITTED, CON_STATUS_RETURNAPPROVED, CON_STATUS_RETURNREJECTED, CON_STATUS_RETURNSAVED,CON_STATUS_RETURN_SUBMITTED].includes(statusCode) ? (
                 <Button
                  variant="contained"
                  color="primary"
                  size="small"
                  sx={{ ...styles.btn_primary }}
                  onClick={() => handleOpenPdf("Debit Note")}
                >
                View Debit Note
                </Button>
              ): null}
             
             {[CON_STATUS_RETURNSUBMITTED, CON_STATUS_RETURNAPPROVED, CON_STATUS_RETURNREJECTED, CON_STATUS_RETURNSAVED,CON_STATUS_RETURN_SUBMITTED].includes(statusCode) ? (
                <Button
                  variant="contained"
                  color="primary"
                  size="small"
                  sx={{ ...styles.btn_primary }}
                  onClick={() => handleOpenPdf("Return Note")}
                >
                  View Return Note
                </Button>
              ) : ![CON_STATUS_RETURN,CON_STATUS_HOLDREJECTED].includes(statusCode) ? (
                <Button
                  variant="contained"
                  color="primary"
                  size="small"
                  sx={{ ...styles.btn_primary }}
                  onClick={() => handleOpenPdf("Rejection Note")}
                >
                  View Reject Note
                </Button>
              ): null}



            </Grid>
          )}
        </Grid>
      </Box>
      <Divider />

      <Dialog
        open={openPdf}
        onClose={() => setOpenPdf(false)}
        fullWidth
        maxWidth="md"
      >
        <DialogTitle>
          {docType} Preview
          <IconButton
            aria-label="close"
            onClick={() => setOpenPdf(false)}
            sx={{
              position: "absolute",
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <DisabledByDefaultOutlinedIcon />
          </IconButton>
        </DialogTitle>

        <DialogContent dividers>
          {docType === "Return Note" ? (
            <ReturnNotePdf
              grnHeader={grnHeader}
              grnItems={grnItems}
              docType={docType}
              selectedSupplier={selectedSupplier}
              grnDetailsForm={grnDetailsForm}
              grnPaySummery={grnPaySummery}
              grnReturns={grnReturns}
              grnData={grnData}
              grnCompany={grnCompany}
              grnReturnList={grnReturnList}
                 
            />
          ) : docType === "Rejection Note" ? (
            <RejectionNotePdf
              grnHeader={grnHeader}
              docType={docType}
              grnItems={grnItems}
              selectedSupplier={selectedSupplier}
              grnDetailsForm={grnDetailsForm}
              grnPaySummery={grnPaySummery}
              grnData={grnData}
              grnReturns={grnReturns}
              grnCompany={grnCompany}
                
            />
          ) : docType === "Debit Note" ? (
            <DebitNotePdf
              grnHeader={grnHeader}
              grnItems={grnItems}
              docType={docType}
              selectedSupplier={selectedSupplier}
              grnDetailsForm={grnDetailsForm}
              grnPaySummery={grnPaySummery}
              grnReturns={grnReturns}
              grnData={grnData}
              grnCompany={grnCompany}
              grnReturnList={grnReturnList}
                 
            />)
          
          
          : (
            <GrnPdf
              docType={docType}
              grnHeader={grnHeader}
              grnItems={grnItems}
              selectedSupplier={selectedSupplier}
              grnPaySummery={grnPaySummery}
              grnData={grnData}
              grnDetailsForm={grnDetailsForm}
              grnCompany={grnCompany}
          grnReturns={grnReturns}
         
            />
          )}
        </DialogContent>
      </Dialog>

      <SystemAlert
        open={alert.open} 
        type={alert.type}
        message={alert.message}
        onClose={handleAlertClose}
      />
    </>
  );
}

export default ViewReturnDetailsBody;

